import { useState } from "react";
import { Pencil, Trash2, Check, X } from "lucide-react";
import { ShelfBook } from "@/components/library/ShelfBook";

const ShelfTitle = ({ shelf, count, onRename, onDelete }) => {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(shelf.name);
  const id = shelf.shelf_id || "unsorted";
  const submit = (e) => { e.preventDefault(); if (name.trim()) onRename(shelf.shelf_id, name.trim()); setEdit(false); };
  if (edit) return (
    <form onSubmit={submit} className="flex items-center gap-2">
      <input autoFocus value={name} maxLength={60} onChange={(e) => setName(e.target.value)} className="neu-inset rounded-full px-4 py-1.5 text-sm focus:outline-none" data-testid={`shelf-rename-input-${id}`} />
      <button className="rounded-full p-1.5 text-[#3D3DF0] hover:bg-[#E2E8F3]" aria-label="Save name" data-testid={`shelf-rename-save-${id}`}><Check className="h-4 w-4" /></button>
      <button type="button" onClick={() => { setName(shelf.name); setEdit(false); }} className="rounded-full p-1.5 text-[#64748B] hover:bg-[#E2E8F3]" aria-label="Cancel"><X className="h-4 w-4" /></button>
    </form>
  );
  return (
    <div className="flex items-center gap-3">
      <h2 className="font-display text-lg font-extrabold tracking-tight" data-testid={`shelf-name-${id}`}>{shelf.name}</h2>
      <span className="rounded-full bg-[#3D3DF0]/10 px-2 py-0.5 font-mono text-[10px] font-bold text-[#3D3DF0]" data-testid={`shelf-count-${id}`}>{count}</span>
      {shelf.shelf_id && (
        <>
          <button onClick={() => setEdit(true)} className="rounded-full p-1.5 text-[#64748B] opacity-60 hover:bg-[#E2E8F3] hover:opacity-100" aria-label="Rename shelf" data-testid={`shelf-rename-${id}`}><Pencil className="h-3.5 w-3.5" /></button>
          <button onClick={() => onDelete(shelf)} className="rounded-full p-1.5 text-[#A62B8A] opacity-60 hover:bg-[#A62B8A]/10 hover:opacity-100" aria-label="Delete shelf" data-testid={`shelf-delete-${id}`}><Trash2 className="h-3.5 w-3.5" /></button>
        </>
      )}
    </div>
  );
};

export const ShelfRow = ({ shelf, books, shelves, onMove, onDeleteBook, onRename, onDelete }) => {
  const [over, setOver] = useState(false);
  const id = shelf.shelf_id || "unsorted";
  const drop = (e) => {
    e.preventDefault(); setOver(false);
    const bookId = e.dataTransfer.getData("text/book-id");
    if (bookId) onMove(bookId, shelf.shelf_id);
  };
  return (
    <section className="rise" data-testid={`shelf-${id}`}>
      <ShelfTitle shelf={shelf} count={books.length} onRename={onRename} onDelete={onDelete} />
      <div
        onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = "move"; setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={drop}
        className={`relative mt-4 rounded-3xl px-5 pt-6 transition-colors duration-200 ${over ? "bg-[#3D3DF0]/[.07] ring-2 ring-[#3D3DF0]/40" : ""}`}
        data-testid={`shelf-dropzone-${id}`}
      >
        <div className="thin-scroll relative z-10 flex min-h-[220px] items-end gap-7 overflow-x-auto pb-1 pl-1 pr-4 pt-5">
          {books.length === 0
            ? <p className="mb-[76px] text-sm italic text-[#94A3B8]" data-testid={`shelf-empty-${id}`}>Drag books here to fill this shelf.</p>
            : books.map((b) => <ShelfBook key={b.book_id} b={b} shelves={shelves} onDelete={onDeleteBook} onMove={onMove} />)}
        </div>
        <div aria-hidden className="shelf-plank pointer-events-none absolute inset-x-0 bottom-[40px] h-5 rounded-xl">
          <div className="brand-strip absolute inset-x-6 -bottom-[3px] h-[3px] rounded-full opacity-60" />
        </div>
      </div>
    </section>
  );
};
